export default __webpack_public_path__ + "static/media/Inter-ThinItalic.6b5565d7.woff";